// The bundle's release version (stamped by vite.config.ts; also the source-map release).

// cyborg-v0.0.760 / relay-v0.0.345 / cyborg-mobile-v1.2.3 → the semver; a branch → undefined.
export function versionFromRef(ref: string | undefined): string | undefined {
  if (!ref) return undefined;
  return /^[a-z][a-z-]*-v(\d+\.\d+\.\d+(?:[-+][\w.-]+)?)$/.exec(ref)?.[1];
}

export function resolveReleaseVersion(env: Record<string, string | undefined>): string {
  const explicit = env.CYBORG7_APP_VERSION?.trim();
  if (explicit) return explicit;
  const tagged = versionFromRef(env.GITHUB_REF_NAME);
  if (tagged) return tagged;
  const sha = env.GITHUB_SHA?.slice(0, 12);
  return sha ? `0.0.0-dev+${sha}` : "0.0.0-dev";
}

declare const __CYBORG7_UI_VERSION__: string | undefined;

export function appVersion(): string | undefined {
  return typeof __CYBORG7_UI_VERSION__ === "string" ? __CYBORG7_UI_VERSION__ : undefined;
}
